import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import Layout from '@/components/Layout/Layout'

// Pages
import LoginPage from '@/pages/LoginPage'
import ConfirmEmailPage from '@/pages/ConfirmEmailPage'
import ResetPasswordPage from '@/pages/ResetPasswordPage'
import DashboardPage from '@/pages/DashboardPage'
import OrganizersPage from '@/pages/OrganizersPage'
import OrganizerDetailsPage from '@/pages/OrganizerDetailsPage'
import EventsPage from '@/pages/EventsPage'
import EventDetailsPage from '@/pages/EventDetailsPage'
import VenuesPage from '@/pages/VenuesPage'
import VenueDetailsPage from '@/pages/VenueDetailsPage'
import SingersPage from '@/pages/SingersPage'
import SingerDetailsPage from '@/pages/SingerDetailsPage'
import SuperAdminSettingsPage from '@/pages/SuperAdminSettingsPage'
import RevenuePage from '@/pages/RevenuePage'

/**
 * Main router configuration for SuperAdmin app
 */
export default function Router() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/confirm-email/:token" element={<ConfirmEmailPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="/organizers" element={<OrganizersPage />} />
        <Route path="/organizers/:id" element={<OrganizerDetailsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailsPage />} />
        <Route path="/venues" element={<VenuesPage />} />
        <Route path="/venues/:id" element={<VenueDetailsPage />} />
        <Route path="/singers" element={<SingersPage />} />
        <Route path="/singers/:id" element={<SingerDetailsPage />} />
        <Route path="/revenue" element={<RevenuePage />} />
        <Route path="/settings" element={<SuperAdminSettingsPage />} />
      </Route>

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

